module.exports = __webpack_public_path__ + "img/25-wrangler-nav.b319cf03.png";